import { render, staticRenderFns } from "./CatalogeForAdjustment.vue?vue&type=template&id=a56775b2&scoped=true"
import script from "./CatalogeForAdjustment.vue?vue&type=script&lang=js"
export * from "./CatalogeForAdjustment.vue?vue&type=script&lang=js"
import style0 from "./CatalogeForAdjustment.vue?vue&type=style&index=0&id=a56775b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56775b2",
  null
  
)

export default component.exports